import React, { Component, useState, createRef } from "react";

import "../styles/actionButton.scss";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function ActionButton({
  title,
  disabled = false,
  onClick,
  loading = false,
  leftIconSrc,
}) {
  return (
    <button
      className="external-campaign-action-button"
      disabled={disabled}
      onClick={onClick}
    >
      {!loading && leftIconSrc && (
        <img src={leftIconSrc} alt="icon" className="left-icon" />
      )}
      {loading ? (
        <CircularProgress size={20} style={{ color: "white" }} />
      ) : (
        title
      )}
    </button>
  );
}
